import {usePermissions} from './usePermissions/usePermissions';

interface LicenceStatus {
  isSalesModuleEnabled: boolean;
  isRentalVehicleModuleEnabled: boolean;
}

export const useIsLicenceEnabled = (): LicenceStatus => {
  const [canReadBusinessCase, canReadRentalVehicle] = usePermissions({
    permissionKeys: ['businessCaseRead', 'readRentalVehicle'],
  });

  const isSalesModuleEnabled = canReadBusinessCase;
  const isRentalVehicleModuleEnabled = canReadRentalVehicle;

  return {
    isSalesModuleEnabled,
    isRentalVehicleModuleEnabled,
  };
};
